import { GlobalQuery } from './queries/GlobalQuery';
import { PUBLIC_DATOCMS_READ_API_TOKEN, PUBLIC_ENV_MODE } from '$env/static/public';
import { ContentPageQuery } from '@pages/content/ContentPageQuery';
import { DatoCMSGraphQL } from '@queries/datoCMS';
import { ServicePageQuery } from '@pages/service/ServicePageQuery';
import { FrontPageQuery } from '@pages/front/FrontPageQuery';
import { CasePageQuery, CasesThumbnailsQuery } from '@pages/case/CasePageQuery';
import { BlogPageQuery, BlogsThumbnailsQuery } from '@pages/blog/BlogPageQuery';

class CMS extends DatoCMSGraphQL {
	public async getGlobals() {
		return this.request(GlobalQuery);
	}

	public async getCasesThumbnails(params: { first?: number; skip?: number }) {
		return this.request(CasesThumbnailsQuery(params));
	}

	public async getBlogsThumbnails(params: { first?: number; skip?: number }) {
		return this.request(BlogsThumbnailsQuery(params));
	}

	public async getBlogPage(slug: string) {
		return this.request(BlogPageQuery(slug));
	}

	public async getCasePage(slug: string) {
		return this.request(CasePageQuery(slug));
	}

	public async getContentPage(slug: string) {
		return this.request(ContentPageQuery(slug));
	}

	public async getServicePage(slug: string) {
		return this.request(ServicePageQuery(slug));
	}

	public async getFrontPage(lang: string) {
		return this.request(FrontPageQuery(lang));
	}
}

export const cms = new CMS(PUBLIC_DATOCMS_READ_API_TOKEN, {
	includeDrafts: PUBLIC_ENV_MODE === 'development' || PUBLIC_ENV_MODE === 'preview',
	// excludeInvalid: PUBLIC_ENV_MODE !== 'development'
	excludeInvalid: false
});
